export class IndicatorOut {
  idIndicatorOut: number;
  idIndicator: number;
  name: string;
  index: number | null;

  constructor(
    idIndicatorOut: number,
    idIndicator: number,
    name: string,
    index: number | null,
  ) {
    this.idIndicatorOut = idIndicatorOut;
    this.idIndicator = idIndicator;
    this.name = name;
    this.index = index;
  }

  static fromRaw(raw: any): IndicatorOut {
    return new IndicatorOut(
      raw.idIndicatorOut,
      raw.idIndicator,
      String(raw.name),
      raw.index ?? null,
    );
  }

  clone(): IndicatorOut {
    return new IndicatorOut(
      this.idIndicatorOut,
      this.idIndicator,
      this.name,
      this.index,
    );
  }

  toPayload(): any {
    const payload: any = {
      idIndicator: this.idIndicator,
      name: this.name,
      index: this.index,
    };
    if (this.idIndicatorOut !== null) {
      payload.idIndicatorOut = this.idIndicatorOut;
    }
    return payload;
  }
}
